/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * @ignore
 * It create many instances of MeasurementRuler and place the copies to the sides with 360 degrees of
 * longitude difference between each one.
 * This module has almost the same methods of MeasurementRuler to easy implementation.
 */
/* jshint nomen:false */
define(['display/map', './measurementRuler'], function(L, MeasurementRuler) {
    'use strict';
    var MultiRuler = L.LayerGroup.extend({
        _rulers: [],
        initialize: function(rulerOptions) {
            this._rulers = [];

            // One main rules and 4 clones (two to each side)
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            this._createRuler(rulerOptions);
            L.LayerGroup.prototype.initialize.call(this, this._rulers);

            Object.defineProperty(this, 'options', {
                get: function() {
                    // Remember that all the rules should have the same configuration
                    return this._rulers[0].options;
                }
            });

            Object.defineProperty(this, 'distance', {
                get: function() {
                    // Remember that all the rules should have the same distance
                    return this._rulers[0].distance;
                }
            });

            Object.defineProperty(this, 'latLngs', {
                get: function() {
                    // Remember that all the rules should have the same properties
                    return this._rulers[0].latLngs;
                }
            });
        },
        /**
         * @ignore
         * Adds a new segments to all the rules.
         * @param {L.LatLng} latLng
         */
        addLatLng: function(latLng) {
            var i, offset = 360,
                len = this._rulers.length;
            this._rulers[0].addLatLng(latLng);
            for (i = 1; i + 1 < len; i = i + 2) {
                this._rulers[i].addLatLng(this._getLatLngWithLngOffset(latLng, -offset));
                this._rulers[i + 1].addLatLng(this._getLatLngWithLngOffset(latLng, offset));
                offset += 360;
            }
        },
        /**
         * @ignore
         * Set the ruler path to all the rules.
         * @param {L.LatLng[]} latLngs
         */
        setLatLngs: function(latLngs) {
            var i, offset = 360,
                len = this._rulers.length;
            this._rulers[0].setLatLngs(latLngs);
            for (i = 1; i + 1 < len; i = i + 2) {
                this._rulers[i].setLatLngs(this._getLatLngsWithLngOffset(latLngs, -offset));
                this._rulers[i + 1].setLatLngs(this._getLatLngsWithLngOffset(latLngs, offset));
                offset += 360;
            }
        },
        /**
         * @ignore
         * Returns the last coordinates added to the ruler.
         * @return {L.LatLng}
         */
        getLast: function() {
            return this._rulers[0].getLast();
        },
        /**
         * @ignore
         * Returns the last coordinates of the closest ruler polyline to the given coordinates.
         * @param {L.LatLng} closerLatLng
         * @return {L.LatLng}
         */
        getClosestLast: function(closerLatLng) {
            var lastsLatLngs, closerPoint,
                map = this._map;

            closerPoint = map.latLngToContainerPoint(closerLatLng);

            lastsLatLngs = this._rulers
                // Creating a distances report
                .map(function(ruler) {
                    var rulerLastLatLng = ruler.getLast(),
                        rulerLastPoint = map.latLngToContainerPoint(rulerLastLatLng);
                    return {latLng: rulerLastLatLng, distance: Math.round(rulerLastPoint.distanceTo(closerPoint))};
                })
                // Sorting points from closest to furthers
                .sort(function(a, b) {
                    return a.distance - b.distance;
                });

            if (lastsLatLngs.length > 0) {
                return lastsLatLngs[0].latLng;
            }

            return null;
        },
        _createRuler: function(rulerOptions) {
            var ruler = new MeasurementRuler(rulerOptions);
            this._rulers.push(ruler);
            return ruler;
        },
        _getLatLngsWithLngOffset: function(latLngs, offset) {
            return latLngs.map(function(latLng) {
                return L.latLng(latLng.lat, latLng.lng + offset);
            });
        },
        _getLatLngWithLngOffset: function(latLng, offset) {
            return L.latLng(latLng.lat, latLng.lng + offset);
        }
    });

    return MultiRuler;
});



// WEBPACK FOOTER //
// ./widgets/controls/distanceMeasurement/multiMeasurementRuler.js